import classNames from 'classnames';
import { FC } from 'react';
import styles from './total-equity-chart.module.scss';
import { Tooltip, TooltipPlacement } from '@app/shared/components/tooltip/Tooltip';
import { Pwerm2CalculationDashboardTotalEquityChartYearDto } from '@app/shared/models/contracts/pwerm2-calculation-results-dto';
import { PerYearCapitalStructureForecastTooltip } from '../../shared/per-year-capital-structure/PerYearCapitalStructureForecastTooltip';

const PARENT_CLASSNAME = 'total-equity-chart';

interface InstrumentColumnProps {
  instrumentStack: JSX.Element;
  isExpanded: boolean;
  isEntryColumn?: boolean;
  isLastForecast?: boolean;
  forecastData: Pwerm2CalculationDashboardTotalEquityChartYearDto;
  heightPct: number;
  onClick: () => void;
}

export const Pwerm2InstrumentColumn: FC<InstrumentColumnProps> = ({
  instrumentStack,
  isExpanded,
  isEntryColumn = false,
  isLastForecast = false,
  forecastData,
  heightPct,
  onClick,
}) => {
  const tooltipPlacement = isEntryColumn
    ? TooltipPlacement.Right
    : isLastForecast
    ? TooltipPlacement.Left
    : TooltipPlacement.Top;

  return (
    <Tooltip
      placement={tooltipPlacement}
      className={classNames(
        styles[`${PARENT_CLASSNAME}__column`],
        styles[`${PARENT_CLASSNAME}__forecast-tooltip`],
        {
          [styles[`${PARENT_CLASSNAME}__column--expanded`]]: isExpanded,
        }
      )}
      style={{
        height: `${heightPct}%`,
      }}
      content={
        <PerYearCapitalStructureForecastTooltip
          forecastData={forecastData}
          isEntryTooltip={isEntryColumn}
        />
      }>
      <div style={{ height: '100%' }} onClick={onClick}>
        {instrumentStack}
      </div>
    </Tooltip>
  );
};
